import { Button } from '@/components/UI/Common/Button';
import { ModalWindow } from '@/components/UI/Common/ModalWindow';
import { ROUTES } from '@/config/routes';
import { IApplication } from '@/types/appliction';
import { getBackUrl } from '@/utils/helpers';
import classnames from 'classnames';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
interface Props {
  application: IApplication;
  className?: string;
}
export const UserApplicationItem: React.FC<Props> = ({ className, application }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div
        onClick={() => setShowModal(true)}
        className={classnames(
          className,
          'min-w-0 w-full py-4 md:px-4 lg:px-6 cursor-pointer flex flex-col md:flex-row lg:border border-gray-100 gap-2 lg:gap-4 items-center',
        )}
      >
        <img
          className="shrink-0 shadow-xs rounded-[16px] h-[60px] w-[60px] bg-gray-200 object-fill flex justify-center"
          src={
            application.upload?.path
              ? `${getBackUrl()}/uploads/${application.upload.path}`
              : '/logo-100x22-violet.svg'
          }
        />
        <div className="min-w-0">
          <div className="text-xs max-md:text-center lg:text-lg lg:text-left max-sm:max-w-[10em]">
            {application.title}
          </div>
          {application.description && (
            <div className="hidden lg:block text-xs text-gray-400">{application.description}</div>
          )}
        </div>
      </div>
      {showModal &&
        createPortal(
          <ModalWindow isActive={showModal} onSetActive={() => setShowModal(false)}>
            <>
              <div className="flex gap-2.5 items-center p-6">
                <img
                  className="rounded-3xl h-[74px] w-[74px] bg-gray-200 object-fill"
                  src={
                    application.upload?.path
                      ? `${getBackUrl()}/uploads/${application.upload.path}`
                      : '/logo-100x22-violet.svg'
                  }
                />
                <div>
                  <h2 className="text-lg">{application.title}</h2>
                  {application.description && (
                    <h3 className="text-gray-400 text-sm">{application.description}</h3>
                  )}
                </div>
              </div>
              {application.applicationLinks && (
                <ul className="py-4">
                  {application.applicationLinks.slice(0, 2).map((link) => (
                    <li className="underline text-blue-700 hover:no-underline" key={link.id}>
                      <a href={link.link} target="_blank" rel="noreferrer">
                        {link.title}
                      </a>
                    </li>
                  ))}
                  {application.applicationLinks.length > 2 && (
                    <li className="underline hover:no-underline text-center">
                      <Link to={`${ROUTES.APPLICATION.BY_ID(application.id)}`}>Ещё</Link>
                    </li>
                  )}
                </ul>
              )}
              <div className="flex justify-center gap-2 sm:gap-4 flex-wrap">
                <a href={application.link} target="_blank" rel="noreferrer">
                  <Button
                    variant="primary"
                    size="lg"
                    className="min-w-28 sm:min-w-52"
                    onClick={() => setShowModal(false)}
                  >
                    Открыть
                  </Button>
                </a>
                <Button
                  onClick={() => setShowModal(false)}
                  variant="outline"
                  size="lg"
                  className="min-w-28 sm:min-w-52"
                >
                  Отмена
                </Button>
              </div>
            </>
          </ModalWindow>,
          document.body,
        )}
    </>
  );
};
